module.exports = __webpack_public_path__ + "media/images/all-in-one-420a8be9acb8a3b48ce8c858949e5997.png";